
export default function lowercaseExtension(url: string): string {
  if (!url) {
    return url;
  }

  // Find the last dot in the URL
  const lastDotIndex = url.lastIndexOf('.');

  // If no dot found, or dot is before the last slash (part of domain/path, not extension)
  if (lastDotIndex === -1) {
    return url;
  }

  const lastSlashIndex = url.lastIndexOf('/');
  if (lastDotIndex < lastSlashIndex) {
    return url;
  }

  const baseUrl = url.substring(0, lastDotIndex);
  const extension = url.substring(lastDotIndex + 1);

  // Check if extension contains query parameters or hash
  const queryIndex = extension.indexOf('?');
  const hashIndex = extension.indexOf('#');

  if (queryIndex !== -1 || hashIndex !== -1) {
    const splitIndex = queryIndex !== -1 ? queryIndex : hashIndex;
    const ext = extension.substring(0, splitIndex);
    const rest = extension.substring(splitIndex);
    return `${baseUrl}.${ext.toLowerCase()}${rest}`;
  }

  // Simple case: just lowercase the extension
  return `${baseUrl}.${extension.toLowerCase()}`;
}

